import axios from "axios";

const API_BASE = process.env.REACT_APP_NOT_SECRET_CODE;

export const USE_ORDER_V2_CREATE =
  process.env.REACT_APP_USE_ORDER_V2_CREATE === "true" ||
  process.env.REACT_APP_USE_ORDER_V2 === "true";

const defaultHeaders = (token) => ({
  "Content-Type": "application/json",
  "X-Request-ID": "124",
  "X-Country-Code": "BD",
  "X-Client-Name": "WEBSITE",
  "X-Client-Version": "123",
  Authorization: `Bearer ${token}`,
});

const getRows = (payload) => {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload.data && payload.data.data)) {
    return payload.data.data;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  return [];
};

export const searchOrderSubscribers = (token, query) =>
  axios
    .get(
      `${API_BASE}/leads?status=3&search_subscriber=${encodeURIComponent(
        query,
      )}&records_per_page=20`,
      {
        headers: defaultHeaders(token),
      },
    )
    .then((res) => getRows(res.data));

export const fetchOrderSubscriberCache = (token) =>
  axios
    .get(`${API_BASE}/leads`, {
      params: {
        status: 3,
        records_per_page: 100000,
      },
      headers: defaultHeaders(token),
    })
    .then((res) => getRows(res.data));

export const searchOrderMedicines = (token, query, countryId = "1", store) => {
  let url = `${API_BASE}/medications?search_medication=${encodeURIComponent(
    query,
  )}&item_code=${encodeURIComponent(query)}&title=${encodeURIComponent(
    query,
  )}&records_per_page=20&country=${countryId || "1"}`;

  if (store !== null && store !== undefined && store !== "" && store !== 1) {
    url += `&store=${store}`;
  }

  return axios
    .get(url, {
      headers: defaultHeaders(token),
    })
    .then((res) => getRows(res.data));
};

export const fetchOrderMedicineCache = (token, countryId = "1") =>
  axios
    .get(`${API_BASE}/medications-all`, {
      params: {
        records_per_page: 100000,
        country: countryId || "1",
      },
      headers: defaultHeaders(token),
    })
    .then((res) => getRows(res.data));

export const createMedicineOrderV2 = (token, payload) =>
  axios
    .post(`${API_BASE}/v2/orders`, payload, {
      headers: defaultHeaders(token),
    })
    .then((res) => res.data);

export const createMedicineOrderClassic = (token, payload) =>
  axios
    .post(`${API_BASE}/orders`, payload, {
      headers: defaultHeaders(token),
    })
    .then((res) => res.data);

const uploadHeaders = (token) => {
  const requestHeaders = defaultHeaders(token);
  delete requestHeaders["Content-Type"];
  return requestHeaders;
};

export const uploadOrderPrescriptionFiles = (token, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("presription_file[]", file));

  return axios
    .post(`${API_BASE}/orders/prescription`, formData, {
      headers: uploadHeaders(token),
    })
    .then((res) => res.data);
};

export const uploadOrderDocumentFiles = (token, files, type) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("document_file[]", file));
  if (type) formData.append("document_type", type);

  return axios
    .post(`${API_BASE}/orders/document`, formData, {
      headers: uploadHeaders(token),
    })
    .then((res) => res.data);
};

const unwrapApiResponse = (res) => {
  const payload = res.data;

  if (payload && payload.success === false) {
    const error = new Error(payload.message || "Request failed.");
    error.response = { data: payload };
    throw error;
  }

  return payload;
};

export const importOrderPoDocument = (
  token,
  file,
  b2bId = null,
  leadId = null,
  options = {},
) => {
  const formData = new FormData();
  formData.append("document", file);
  if (b2bId) formData.append("b2b_id", b2bId);
  if (leadId) formData.append("lead_id", leadId);
  if (options.forceAi) formData.append("force_ai", "1");

  return axios
    .post(`${API_BASE}/rfq-requests/import-document`, formData, {
      headers: uploadHeaders(token),
    })
    .then(unwrapApiResponse);
};

export const importOrderPoDocumentUrl = (
  token,
  documentUrl,
  b2bId = null,
  leadId = null,
  options = {},
) =>
  axios
    .post(
      `${API_BASE}/rfq-requests/import-document`,
      {
        document_url: documentUrl,
        b2b_id: b2bId || "",
        lead_id: leadId || "",
        force_ai: options.forceAi ? "1" : "",
      },
      { headers: defaultHeaders(token) },
    )
    .then(unwrapApiResponse);

export const enrichOrderPoLines = (token, lines, b2bId = null, leadId = null) =>
  axios
    .post(
      `${API_BASE}/rfq-medications/enrich-lines`,
      {
        lines,
        b2b_id: b2bId || "",
        lead_id: leadId || "",
      },
      { headers: defaultHeaders(token) },
    )
    .then(unwrapApiResponse);

export const searchOrderPoMedications = (token, query, b2bId = null, leadId = null) =>
  axios
    .get(`${API_BASE}/rfq-medications/search`, {
      params: {
        query,
        item_code: query,
        search_item_code: query,
        b2b_id: b2bId || "",
        lead_id: leadId || "",
      },
      headers: defaultHeaders(token),
    })
    .then(unwrapApiResponse);

export const learnOrderPoLineMapping = (token, payload) =>
  axios
    .post(`${API_BASE}/rfq-line-mappings/learn`, payload, {
      headers: defaultHeaders(token),
    })
    .then(unwrapApiResponse);

export const fetchOrderPoMedicationStock = (token, medicationId, storeId) =>
  axios
    .get(`${API_BASE}/storewise/medicationall/${medicationId}`, {
      params: {
        store_id: storeId,
      },
      headers: defaultHeaders(token),
    })
    .then(unwrapApiResponse);

export const createOrderPoRefillRequest = (token, payload) =>
  axios
    .post(`${API_BASE}/multi-store/create-purchaseRequest-updated`, payload, {
      headers: defaultHeaders(token),
    })
    .then((res) => res.data);
